<template>
  <span>
    <b-spinner
      v-if="state.pending"
      small
      class="mr-50"
      label="Применяется"
    />
    <template v-if="state.visible.length">
      <strong>Посетители видят заглушку</strong>
      <span
        v-for="guard in state.visible"
        :key="guard.guard"
        class="ml-50"
      >
        ({{ guard.destination }}: {{ guard.reason || 'причина неизвестна' }})
      </span>
      <span
        v-if="state.pending === 'off'"
        class="ml-50"
      >
        — ручной флаг снят, edge-router уберёт её в течение ~{{ state.intervalSeconds }} с
      </span>
    </template>
    <template v-else-if="state.pending === 'on'">
      <strong>Заглушка включена в настройках</strong>, но посетители её пока не видят: edge-router покажет её в
      течение ~{{ state.intervalSeconds }} с
    </template>
    <template v-else-if="state.manual && state.noReports">
      <strong>Заглушка включена в настройках</strong>, но edge-router не присылает отчёты — неизвестно, видна ли она
      посетителям
    </template>
    <template v-else-if="state.noReports">
      edge-router не присылает отчёты — неизвестно, что видят посетители
    </template>
    <template v-else>
      <strong>Сайт открыт</strong> — посетители заглушку не видят
    </template>
  </span>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

/** One sentence on what the settings ask for and what visitors actually see; state from describeMaintenance() */
export default {
  name: 'MaintenanceStatusText',
  components: { BSpinner },
  props: {
    state: { type: Object, required: true },
  },
}
</script>
